import { BaseValidator } from '../core/BaseValidator.js';
import { ValidationResult } from '../core/ValidationResult.js';

/**
 * South African ID Number validator following Single Responsibility Principle
 */
export class ZaValidator extends BaseValidator {
  constructor() {
    super({
      name: 'South African ID Number',
      pattern: /^\d{13}$/,
      length: 13
    });
  }

  validateFormat(id) {
    // Check length
    const lengthValidation = this.validateLength(id, this.config.length);
    if (!lengthValidation.isValid) {
      return lengthValidation;
    }

    // Check pattern
    return this.validateRegex(
      id,
      this.config.pattern,
      'South African ID must be exactly 13 digits'
    );
  }

  validateChecksum(id) {
    // Luhn algorithm for South African ID
    let sum = 0;
    let alternate = false;

    for (let i = id.length - 2; i >= 0; i--) {
      let n = parseInt(id[i]);
      
      if (alternate) {
        n *= 2;
        if (n > 9) {
          n = (n % 10) + 1;
        }
      }
      
      sum += n;
      alternate = !alternate;
    }

    const expectedChecksum = (10 - (sum % 10)) % 10;
    const actualChecksum = parseInt(id[12]);

    if (expectedChecksum !== actualChecksum) {
      return ValidationResult.invalid(`Invalid South African ID checksum. Expected: ${expectedChecksum}, Got: ${actualChecksum}`);
    }

    return ValidationResult.valid('Valid South African ID');
  }
}